// extracted by mini-css-extract-plugin
module.exports = {"navigation-card":"CardsTouchScreen_navigation-card__6r9L5"};